module.exports = new __parcel__URL__("basilisk-statue.354071f9.webp").toString();